import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import { InputNumber, Divider, Breadcrumb, Steps, Button, Layout, Spin, Upload, Form, Input, Icon, Row, Col, DatePicker, TimePicker, Select, Card, Radio, Tooltip, BackTop, message, Switch } from 'antd';
import update from 'immutability-helper';
import moment from 'moment'
import { v4 } from 'uuid';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { SALES_ROLE } from '../../constants/overview';
const {Content } = Layout;
const FormItem = Form.Item;
const Option  = Select.Option;
const { TextArea } = Input;

const modules = {
	toolbar: [
		[{ header: [1, 2, false] }],
		["bold", "italic", "underline", "strike", "blockquote"],
		[
			{ list: "ordered" },
			{ list: "bullet" },
			{ indent: "-1" },
			{ indent: "+1" }
		],
		["link", "image"],
		["clean"]
	]
}

const formats = [
	"header",
	"bold",
	"italic",
	"underline",
	"strike",
	"blockquote",
	"list",
	"bullet",
	"indent",
	"link",
	"image"
]

class CreateCalendarEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            data: {
                name: '',
                links: '',
                image: '',
                description: '',
                event_link: '',
                about_event: '',
                start_date: ' ', 
                end_date: ' ',
                start_time: '', 
                end_time: '',
                display_date: '',
                event_address: '', 
                city: '',
                state: '',
                google_map_url: '',
                free: '',
                paid: '',
                price: 0,
                event_options: [],
                location_restriction: [],
                department_restriction: [],
                event_contacts: [],
                status: 1,
                enable_push_notification: true,
                notification_title: '',
                notification_description: '',
                sponsor: JSON.parse(sessionStorage.getItem('company_id')) == null ? '' : sessionStorage.getItem('company_id')
            },
            locations: [],
            departments: [],
            errors: {},
            isLoading: false,
            uploading :true,
            enable_file_input: false,
            locationDepartmentSelect: 'all',
            locationSelect: 'all',
            departmentSelect: 'all',
            fileList: [],
            imageValid: true,
            loading: false,
            draftLoading: false,
            selectedPrice: 0
        };
    }

    componentDidMount(){
      let that = this;
      that.setState({isLoading: true})
      window.axios.get(window.API_URL + 'corporate/events/locations_and_departments')
        .then(function (response) {
          that.setState({locations: response.data["locations"], departments: response.data["departments"], isLoading: false, firstColumnHeight: document.getElementById('firstColumnHeight').clientHeight
        })
          console.log(that.state)
        })
        .catch(function (error) {
          that.setState({isLoading: false})
        console.log(error);
        })  
    }

    handleValidation() {
      let errors = {};
      let formIsValid = true
      let current = this.state.current
      if (Date.parse(moment(this.state.data.display_date).format('DD/MM/YYYY')) > Date.parse(this.state.data.start_date)){
        errors["display_date"] = "Display date can't be greater than start date"
        formIsValid = false
        current = 0
      }
      if (this.state.data.start_date > this.state.data.end_date){
        errors["end_time"] = "End date should be greater than start date"
        formIsValid = false
        current = 0
      }
      if ((this.state.data.start_date === this.state.data.end_date) && (this.state.data.start_time > this.state.data.end_time)){
        errors["end_time"] = "End time should be greater than start time"
        formIsValid = false
        current = 0
      }
      if ((this.state.data.start_date === moment(this.state.data.display_date).format('DD/MM/YYYY')) && (moment(this.state.data.display_date).format('HH:mm') > this.state.data.start_time)){
        errors["display_date"] = "Display time should be before start time"
        formIsValid = false
        current = 0
      }
      this.setState({errors: errors})
      return formIsValid
    }  

    handleChange = ({ fileList }) => {
      if (fileList[0].size >= 150000) {
        message.error('You can upload max 150kb size file and with 343 x 171 dimensions')
        return
      }
      if (fileList.length === 0){
          this.setState({ fileList })
        }else {
          if(fileList[0]["originFileObj"].type === "image/jpeg" || fileList[0]["originFileObj"].type === "image/png" || fileList[0]["originFileObj"] === undefined){
            this.setState({ fileList })
          }else {
            message.error('You can only upload JPEG/PNG file!');
          }
      }
    }

    done (e) {
      const objectToFormData = require('object-to-formdata')
      if(e === 0){
        this.state.data.status = e
      }
      if(this.state.fileList.length > 0){
        this.state.data.image = this.state.fileList[0]["originFileObj"]
      }  
      let formData = objectToFormData(this.state.data)
      this.props.form.validateFields((err, values) => {
      if (!err && this.handleValidation()) {
        this.setState({ loading: true }); 
        fetch(window.API_URL + 'corporate/events/', {
          method: 'POST',
          headers: {
            'x-ekincare-key': sessionStorage.getItem('axiosHeaders')
          },
          body: formData
        }).then(response => { 
          this.setState({ loading: false });
          message.success('Event created successfully'); 
          response.json()
          })

        .then(json => {
           this.props.history.push('/wellness-calendar/events') 
        })
        .catch((error) => {
          this.setState({ loading: false });
          alert('Failed to create')
        });
      } else {
        alert('Form has errors.')
      } 
      });
    }

    draftDone (e) {
      const objectToFormData = require('object-to-formdata')
      if(e === 0){
        this.state.data.status = e
      }
      if(this.state.fileList.length > 0){
        this.state.data.image = this.state.fileList[0]["originFileObj"]
      }  
      let formData = objectToFormData(this.state.data)
      this.props.form.validateFields((err, values) => {
      if (!err && this.handleValidation()){
        this.setState({ draftLoading: true }); 
        fetch(window.API_URL + 'corporate/events/', {
          method: 'POST',
          headers: {
            'x-ekincare-key': sessionStorage.getItem('axiosHeaders')
          },
          body: formData
        }).then(response => { 
          this.setState({ draftLoading: false });
          message.success('Event created successfully'); 
          response.json()
          })

        .then(json => {
           this.props.history.push('/wellness-calendar/events') 
        })
        .catch((error) => {
          this.setState({ draftLoading: false });
          alert('Failed to create')
        });
      } else {
        alert('Form has errors.')
      } 
      });
    }



    updateName = (e) => {
      let updated = update(this.state.data, {name: {$set: e.target.value}, notification_title: {$set: e.target.value + ' is Coming Up!'}})
      this.setState({data: updated})
    }

    updateEventLink = (e) => {
      let value = e.target.value
      let updated = update(this.state.data, {event_link: {$set: e.target.value} })
      this.setState({data: updated})
    }

    updateImage = (e) => {
      let updated = update(this.state.data, {image: {$set: e.target.files[0]}})
      this.setState({data: updated, enable_file_input: false})
    }

    updateStartDate = (date, dateString) => {
      let updated = update(this.state.data, {start_date: {$set: dateString }})
      this.setState({data: updated})
    }

    updateEndDate = (date, dateString) => {
      let updated = update(this.state.data, {end_date: {$set: dateString }})
      this.setState({data: updated})
    }

    updateStartTime = (date, dateString) => {
      let updated = update(this.state.data, {start_time: {$set: dateString }})
      this.setState({data: updated})
    }

    updateEndTime = (date, dateString) => {
      let updated = update(this.state.data, {end_time: {$set: dateString }})
      this.setState({data: updated})
    }

    updateEventAddress = (e) => {
      let updated = update(this.state.data, {event_address: {$set: e.target.value }})
      this.setState({data: updated})
    }

    updateDescription = (value) => {
      let updated = update(this.state.data, { description: { $set: value } });
      this.setState({ data: updated });
    };

    updateRichText = (type,value) => {
      if (type === 'about') {
        let updated = update(this.state.data, {about_event: {$set: value}})
        this.setState({data: updated})
      } else if(type === 'desc') {
        let updated = update(this.state.data, {description: {$set: value}})
        this.setState({data: updated})
      }
    }

    updateDisplayDate = (date, dateString) => {
      let updated = update(this.state.data, {display_date: {$set: dateString }, notification_description: {$set: "Don't miss out! Join us for " + this.state.data.name + ' on ' + moment(dateString).format('DD MMM YYYY hh:mm A') + '. RSVP now for a memorable experience!'}})
      this.setState({data: updated})
    }

    disabledStartDates = current => {
      if ( current && current < moment().subtract(1, 'days').endOf('day')){
        return current
      }else{
        return false
      }
    }

    disabledEndDates = current => {
      let start_date = this.state.data.start_date.split("/").reverse()
      var end_date = new Date(start_date)
      if ( current && current < moment().subtract(1, 'days').endOf('day')){
        return current
      }
      else if (current && current < end_date) {
        return current
      }else{
        return false
      }
    }

    disabledDisplayDates = current => {
      let start_date = this.state.data.start_date.split("/").reverse()
      var from_date = new  Date(start_date)
      if ( current && current < moment().subtract(1, 'days').endOf('day')){
        return current
      }
      else if (current && current > from_date.setDate(from_date.getDate()+1)) {
        return current
      }else{
        return false
      }
    }

    addContact(i) {
      let data = this.state.data ? this.state.data : {}
      let contact = {cid: v4(),name:'', mobile: '', email: ''} 
      data.event_contacts.push(contact)
      this.setState({data: data})
    }

    removeContact (i) {
      let data = this.state.data ? this.state.data : {}
      data.event_contacts.splice(i, 1)
      this.setState({data: data})
    }

    updateContactName (i, e) {
      let data = this.state.data ? this.state.data : {}
      data.event_contacts[i].name = e.target.value
      this.setState({data: data})
    }

    updateContactMobile (i, e) {
      let data = this.state.data ? this.state.data : {}
      data.event_contacts[i].mobile = e.target.value
      this.setState({data: data})
    }

    updateContactEmail (i, e) {
      let data = this.state.data ? this.state.data : {}
      data.event_contacts[i].email = e.target.value
      this.setState({data: data})
    }

    removeOption = (i, j) => {
      let data = Object.assign({}, this.state.data)
      if (this.state.data.event_options[i]["options"].length <= 1){
        if(j === 0) {
          data.event_options.splice(i, 1)
          if(i === 0){ this.setState({displayMessage: false}) }
        }     
      }else{
        data.event_options[i].options.splice(j, 1)
      }  
      this.setState({data: data})
    }

    addOption = (i) => {
      let data = Object.assign({}, this.state.data)
      let options = {oid: v4(),limit: '', name: ''}
      data.event_options[i].options.push(options)
      this.setState({data: data})
    }

    addPollQuestion(i) {
      let data = Object.assign({}, this.state.data)
      let poll = {qid: v4(),name: '', options: [{oid: v4(),limit: '', name: ''}]}
      data.event_options.push(poll)
      this.setState({data: data, displayMessage: true})
    }

    updateQuestionChange (i, e) {
      let data = Object.assign({}, this.state.data)
      data.event_options[i].name = e.target.value
      this.setState({data: data})
    }

    updateOptionNameChange (i, j, e) {
      let data = Object.assign({}, this.state.data)
      data.event_options[i].options[j].name = e.target.value
      this.setState({data: data})
    }

    updateOptionLimitChange (i, j, e) {
      let data = Object.assign({}, this.state.data)
      let limit = e.target.value ? parseInt(e.target.value) : 0
      data.event_options[i].options[j].limit = limit
      this.setState({data: data})
    }
  
    changePrice = e => {
      console.log('radio checked', e.target.value);
      this.setState({
        selectedPrice: e.target.value
      });
    };

    handleChangePrice(price) {
      let data = this.state.data
      data.price = price
      this.setState({data: data})
    }

    handleLocationChange = (e) => {
      let data = this.state.data
      if(e.target.value === 'all') {
        data.location_restriction = []
      } 
      this.setState({ locationSelect: e.target.value, data: data });
    }

    handleDepartmentChange = (e) => {
      let data = this.state.data
      if(e.target.value === 'all') {
        data.department_restriction = []
      } 
      this.setState({ departmentSelect: e.target.value, data: data });
    }

    handleSelectLocationChange(loc) {
    // console.log(loc)
      let data = this.state.data
      data.location_restriction = loc 
      this.setState({data: data})
    }
    handleSelectDepartmentChange(dept) {
      let data = this.state.data
      data.department_restriction = dept 
      this.setState({data: data})
    }

    updatePushNotificationStatus = val => {
      let data = this.state.data
      data.enable_push_notification = val
      this.setState({data: data})
    };

    updateNotificationTitle = event => {
      let data = this.state.data
      data.notification_title = event.target.value
      this.setState({data: data})
    };

    updateNotificationDescription = event => {
      let data = this.state.data
      data.notification_description = event.target.value
      this.setState({data: data})
    };

    handleShowDepartments(){
      let that = this
      let departments = this.state.departments
      let { getFieldDecorator } = this.props.form;
      if(that.state.departmentSelect === 'all') {
        return(<div style={{marginTop: '-20'}}></div>)
      }else{
        return(
          <div>
            {getFieldDecorator('department_restriction', {
                      rules: [{ required: true, message: 'Please select Department' }],
                      })(
              <Select
                mode="multiple"
                style={{ width: '100%', marginTop: 10, backgroundColor: '#fff' }}
                placeholder="Select from the list"
                onChange={that.handleSelectDepartmentChange.bind(that)}
              >
                {
                    departments.map(function(dept, i) {
                        return (
                            <Option value={dept} key={i}>{dept}</Option>
                        )
                    })
                }
              </Select>
            )}  
          </div>
        )
      }
    }

    enterPrice(){
      let that = this
      let { getFieldDecorator } = this.props.form;
      if(that.state.selectedPrice === 0) {
        return(<div style={{marginTop: '-20'}}></div>)
      }else{
        return(
          <div>
            {getFieldDecorator('price', {

                      rules: [{ required: true, message: 'Please enter price greater than 0' }],
                      })(
              <InputNumber min={1} style={{marginBottom: 5}} onChange={that.handleChangePrice.bind(that)}/>
              )}
          </div>
        )
      }
    }

    handleShowLocations(){
      let that = this
      let locations = this.state.locations
      let { getFieldDecorator } = this.props.form;
      if(that.state.locationSelect === 'all') {
        return(<div style={{marginTop: '-20'}}></div>)
      }else{
        return(
          <div>
            {getFieldDecorator('location_restriction', {

                      rules: [{ required: true, message: 'Please select Location' }],
                      })(
              <Select
                mode="multiple"
                style={{ width: '100%', marginTop: 10, backgroundColor: '#fff' }}
                placeholder="Select from the list"
                onChange={that.handleSelectLocationChange.bind(that)}
                
              >
                {
                    locations.map(function(loc, i) {
                        return (
                            <Option value={loc} key={i}>{loc}</Option>
                        )
                    })
                }
              </Select>
              )}
          </div>
        )
      }
    }

    renderDisplayDate(){
      let display_date = this.state.data.display_date
      let { getFieldDecorator } = this.props.form;
      if (display_date !== "" && display_date !== null && display_date !== undefined){
        return (
        <div>
        {getFieldDecorator('display_date', {
                      initialValue: moment(display_date, "YYYY-MM-DD HH:mm"),
                      rules: [{ required: true, message: 'Please select Display Date' }],
                      })(
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder="Select Date & Time"
            onChange={this.updateDisplayDate}
            disabledDate={this.disabledDisplayDates}
          />
          )}
        </div>  
        )
      }
      else{
        return(
        <div>
        {getFieldDecorator('display_date', {
                      initialValue: display_date,
                      rules: [{ required: true, message: 'Please select Display Date' }],
                      })(
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder="Select Date & Time"
            onChange={this.updateDisplayDate}
            disabledDate={this.disabledDisplayDates}
          />
        )}  
      </div>  
        )
      }
    }

    pollQuestionValidMessage(){
      let that = this
      if (that.state.displayMessage === true) {
        return(<p style={{color: "red",marginTop: '-10',marginBottom: '-10'}}> * If poll questions are created, they can't be edited </p>)
      }
    }

    enableFileInput(enable){
      this.setState({enable_file_input: enable})
    }

    renderCalendar(){
      this.props.history.push('/wellness-calendar') 
    }

    render(){
      const  formItemLayout  = null;
      const { fileList } = this.state;
      let { getFieldDecorator } = this.props.form;
      const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
          onSuccess("ok");
        }, 0);
      };
      let start_date = this.state.data.start_date ? moment(this.state.data.start_date, 'DD/MM/YYYY') : null
      let end_date = this.state.data.end_date ? moment(this.state.data.end_date, 'DD/MM/YYYY') : null
      let start_time = this.state.data.start_time ? moment(this.state.data.start_time, 'HH:mm') : null
      let end_time = this.state.data.end_time ? moment(this.state.data.end_time, 'HH:mm') : null
      let event_contacts = this.state.data.event_contacts
      let event_options = this.state.data.event_options
      let disabled_end_date = start_date ? false : true
      let disabled_end_time = start_time ? false : true
      let errors = this.state.errors
      let that = this
      return(
        <div id="fullevent">
          <Card style={{width: '100%', marginTop: 24 }}>
            <Row gutter={24}>
            <Col span={6} className="gutter-row">
                  <h2 className="semibold"> Create Event </h2>
            </Col>  
            <Col span={18} className="gutter-row"> 
              <Row type="flex" justify="end" gutter={18}> 
                
                  <a onClick={this.renderCalendar.bind(this)}><h3 style={{marginTop: 8,color: "#2168f3"}}><Icon type="left" style={{color: '#2168f3'}} /> Calendar</h3></a>
                
                
                  <Button type="default" onClick={() => this.draftDone(0)} style={{float: 'right', marginLeft: 20}} disabled={SALES_ROLE === "sales"} loading={this.state.draftLoading}>Save as Draft</Button>
                
                
                  <Button type="primary" onClick={() => this.done(1)} style={{float: 'right', marginLeft: 20}} disabled={SALES_ROLE === "sales"} loading={this.state.loading}>Schedule now</Button>
                
              </Row>  
            </Col> 
            </Row>
            <Form hideRequiredMark={true}>
              <Row gutter={24}>
                <Col span={11} className="gutter-row">
                  <FormItem {...formItemLayout} label="Event Title" colon={false} >
                    {getFieldDecorator('name', {
                      initialValue: this.state.data.name,
                    rules: [{ required: true, message: 'Please enter your event title' }],
                    })(
                    <Input onChange={this.updateName}/>
                    )}
                  </FormItem>
                </Col>
                <Col span={12} className="gutter-row">
                  <FormItem {...formItemLayout} label = "Display Image" colon={false} >
                    <Upload
                      accept=".jpeg,.png"
                      customRequest={dummyRequest}
                      listType="picture"
                      fileList={fileList}
                      onChange={this.handleChange}
                     
                      className="upload-list-inline"
                    >
                      {fileList.length > 0 ? null : <Button> <Icon type="upload" /> Upload </Button>}
                    </Upload>
                  </FormItem>
                </Col>
              </Row>  
              <Row gutter={24}> 
                <Col span={24} className="gutter-row" style={{marginTop: '-12'}}>
                  <Row type="flex" justify="start" gutter={24}>
                    <FormItem {...formItemLayout} label="Start Date & Time" colon={false} style={{marginTop: '-12',float: 'right', marginLeft: 12}}>
                      {getFieldDecorator('start_date', {
                      initialValue: start_date, 
                      rules: [{ required: true, message: 'Please select Start Date' }],
                      })(
                      <DatePicker format= 'DD/MM/YYYY'
                       onChange={this.updateStartDate} disabledDate={this.disabledStartDates} placeholder="Start date" />
                      )}
                      <span style={{color: "red"}}>{this.state.errors["start_date"]}</span>
                    </FormItem>  
                    <FormItem {...formItemLayout} label="" colon={false}  style={{marginTop: '-12', float: 'right', marginLeft: 20}}>
                      {getFieldDecorator('start_time', {
                      initialValue: start_time,
                      rules: [{ required: true, message: 'Please select Start Time' }],
                      })(
                      <TimePicker format='HH:mm' onChange={this.updateStartTime} style={{ marginRight: 0,marginTop: 47}} placeholder="Time" />
                      )}  
                      <span style={{color: "red"}}>{this.state.errors["start_time"]}</span>
                    </FormItem>
                    <FormItem {...formItemLayout} label="" style={{marginTop: '-12', float: 'right',marginLeft: 20}}>
                      <p style={{marginTop: 43,marginBottom: 0}}>To</p>
                    </FormItem>
                    <FormItem {...formItemLayout} label="End Date & Time" colon={false} style={{marginTop: '-12', float: 'right', marginLeft: 20}}>  
                      {getFieldDecorator('end_date', {
                      initialValue: end_date,  
                      rules: [{ required: true, message: 'Please select End Date' }],
                      })(
                      <DatePicker format= 'DD/MM/YYYY'  
                       onChange={this.updateEndDate} disabledDate={this.disabledEndDates} style={{paddingLeft: 0}} placeholder="End date" disabled={disabled_end_date} />
                      )}
                    </FormItem>  
                    <FormItem {...formItemLayout} label="" colon={false} style={{marginTop: '-12',float: 'right', marginLeft: 20}}>
                      {getFieldDecorator('end_time', {
                      initialValue: end_time,
                      rules: [{ required: true, message: 'Please select End Time' }],
                      })(
                      <TimePicker format='HH:mm' onChange={this.updateEndTime} style={{paddingLeft: 0,marginTop: 47}} placeholder="Time" disabled={disabled_end_time}  />
                      )}
                      <span style={{color: "red"}}>{this.state.errors["end_time"]}</span>
                    </FormItem>
                  </Row>
                </Col>  
              </Row>
              <Row gutter={24}>
                <Col span={11} className="gutter-row" id="firstColumnHeight">
                  <FormItem {...formItemLayout} style={{marginBottom: '-10'}} label="Who all can participate ?" colon={false}>
                  <p style={{lineHeight: '1.15',fontSize: 12,marginBottom: 5,color: '#A2A2A2'}}>You can use this option to show this event only to employees who belong to a specific location and department. Only those locations or departments which are shared for an employee profile during pre-registration will be shown, to modify the same please reach out to your account manager.</p>
                    <FormItem {...formItemLayout} style={{marginLeft: 12,marginBottom: 0}}>
                      <Radio.Group value={that.state.locationSelect} onChange={that.handleLocationChange.bind(that)}>
                        <Radio value="all">All Locations</Radio>
                        <Radio value="selected" style={{marginLeft: 20}}>Selected Locations</Radio>
                      </Radio.Group>
                      {this.handleShowLocations()}
                    </FormItem>  
                    <FormItem {...formItemLayout} style={{marginLeft: 12,marginBottom: 30}}>  
                      <Radio.Group value={that.state.departmentSelect} onChange={that.handleDepartmentChange.bind(that)}>
                        <Radio value="all">All Departments</Radio>
                        <Radio value="selected">Selected Departments</Radio>
                      </Radio.Group>
                      {this.handleShowDepartments()}
                    </FormItem>
                  </FormItem>
                  <FormItem {...formItemLayout} label="Location" colon={false} style={{marginBottom: 25}}>
                    {getFieldDecorator('event_address', {
                    initialValue: this.state.data.event_address,  
                    rules: [{ required: true, message: 'Please enter Address' }],
                    })(
                    <TextArea placeholder= "Building No." onBlur={this.updateEventAddress} autosize={{ minRows: 2, maxRows: 6 }}/>
                    )}
                  </FormItem>
                  <Form layout={'vertical'}>
                    <FormItem {...formItemLayout} label="Description" colon={false}>
                      <ReactQuill
                        theme="snow"
                        onChange={(e) => this.updateDescription(e)}
                        name="tertiary_info"
                        defaultValue={this.state.data.description || ''}
                        modules={modules}
                        formats={formats}
                      >
                      </ReactQuill>
                    </FormItem>
                    <FormItem {...formItemLayout} label="Event Link" colon={false} >
                      {getFieldDecorator('event_link', {
                        initialValue: this.state.data.event_link,
                      rules: [{ required: true, message: 'Please enter your event link' },
                              { type: 'url', message: 'Please enter a valid URL' }],
                      })(
                      <Input onChange={this.updateEventLink}/>
                      )}
                  </FormItem>
                  <FormItem {...formItemLayout} label={(<span>Contact person &nbsp; <a onClick={that.addContact.bind(that)} style={{color: '#2168f3'}}> <Icon type="plus" style={{color: '#2168f3'}}/> Add Organiser</a></span>)} colon={false} style={{marginBottom: 0}}>
                  <p style={{lineHeight: '1.15',fontSize: 12,color: '#A2A2A2'}}>Adding at least one contact person would be helpful for your employees to reach out in case of any queries regarding the event.</p>      
                    {
                        event_contacts.map(function(obj, i){
                            return (
                                <FormItem {...formItemLayout} key={i}>
                      
                                <Row gutter={24} key={i}>
                                    <Col className="gutter-row" span={6}>
                                      <FormItem {...formItemLayout} >
                                        {getFieldDecorator( obj.cid.toString(), {
                                          initialValue: obj.name,
                                          rules: [{ required: true, message: 'Please enter name' }],
                                        })( 
                                        <Input placeholder= "Name" onBlur={that.updateContactName.bind(that, i)}/>
                                        )}
                                      </FormItem>  
                                    </Col>
                                    <Col className="gutter-row" span={8}>
                                      <FormItem {...formItemLayout} >
                                        {getFieldDecorator( (obj.cid + 1).toString(), {
                                          initialValue: obj.mobile,
                                          rules: [{ required: true, message: 'Please enter number' }],
                                        })( 
                                        <Input placeholder= "Mobile Number" onBlur={that.updateContactMobile.bind(that, i)}/>  
                                        )}
                                      </FormItem>  
                                    </Col>
                                    <Col className="gutter-row" span={8}>
                                      <FormItem {...formItemLayout} >
                                        {getFieldDecorator( (obj.cid + 2).toString(), {
                                          initialValue: obj.email,
                                          rules: [{ required: true, message: 'Please enter email' }],
                                        })( 
                                        <Input placeholder= "Email" defaultValue={obj.email} onBlur={that.updateContactEmail.bind(that, i)}/>  
                                        )}
                                      </FormItem>
                                    </Col>
                                    {i >= 0 ? (
                                        <Icon className="dynamic-delete-button" type="minus-circle-o"
                                        onClick={that.removeContact.bind(that, i)}
                                        />
                                        // </Col>
                                    ) : null}
                                </Row>

                                </FormItem>
                            )
                        })
                    }
                  </FormItem>
                  <FormItem {...formItemLayout} label={(<span>Create a Poll &nbsp; <a onClick={that.addPollQuestion.bind(that)} style={{color: '#2168f3'}}> <Icon type="plus" style={{color: '#2168f3'}} /> Add Poll Question</a></span>)} colon={false}  style={{marginBottom: 10}}>
                  <p style={{lineHeight: '1.15',fontSize: 12,color: '#A2A2A2'}}>This option is useful incase you would like to create a poll with different options to select. Here, you also have a choice to limit the number of slots available.</p>
                    {this.pollQuestionValidMessage()}
                    
                    {event_options.map(function(object, i){
                      return (
                        <div key={i}>
                            <FormItem {...formItemLayout} label={(<span> Poll Question (optional) &nbsp; <a onClick={that.removeOption.bind(that,i,0)}><Icon type="delete" style={{color: 'red'}} /></a></span>)} >   
                              {getFieldDecorator( object.qid.toString(), {
                              initialValue: object.name,  
                              rules: [{ required: true, message: 'Please enter Question' }],
                              })(                   
                                <Input placeholder= "Poll Question to be asked to employee (100 characters max.)"
                                     onBlur={that.updateQuestionChange.bind(that, i)}/> 
                              )}        
                            </FormItem>
                            {
                              object.options.map(function(obj, j){
                                return (
                                    <Row gutter={24} key={j}>
                                        <Col className="gutter-row" span={11}>
                                          <FormItem {...formItemLayout} >
                                            {getFieldDecorator( obj.oid.toString(), {
                                            initialValue: obj.name,  
                                            rules: [{ required: true, message: 'Please enter option' }],
                                            })(
                                              <Input placeholder= "option (required)" onBlur={that.updateOptionNameChange.bind(that, i, j)}/>
                                            )}
                                          </FormItem>
                                        </Col>
                                        <Col className="gutter-row" span={11}>
                                            <FormItem {...formItemLayout} >
                                                <Input placeholder= "Slot limit" defaultValue={obj.limit} onBlur={that.updateOptionLimitChange.bind(that, i, j)}/>
                                            </FormItem>
                                        </Col>
                                        {j >= 0 ? (
                                            <Icon
                                            className="dynamic-delete-button"
                                            type="minus-circle-o"
                                            // disabled={keys.length === 1}
                                            onClick={that.removeOption.bind(that, i, j)}
                                            />
                                        ) : null}
                                    </Row>
                                )
                              })
                            }
                            <FormItem {...formItemLayout}>
                              <Button type="dashed" onClick={that.addOption.bind(that, i)} style={{ width: '100%' }}>
                                  <Icon type="plus" /> Add option
                              </Button>
                            </FormItem>
                        </div>
                      )
                    })}                  
                  </FormItem>
                  </Form>  
                </Col>
                <Col span={11} className="gutter-row" style={{borderLeft: '1px solid #e8e8e8',minHeight: that.state.firstColumnHeight}}>
                  <FormItem {...formItemLayout} label="Enter price" colon={false} style={{marginBottom: 11}}>
                    <Radio.Group onChange={this.changePrice} value={this.state.selectedPrice} style={{marginLeft: 12,marginBottom: 11}}>
                      <Radio value={0}>Free</Radio>
                      <Radio value={1}>Paid</Radio>
                    </Radio.Group>
                    {this.enterPrice()}   
                  </FormItem> 
                  <FormItem {...formItemLayout} label="When should it display on app ?" colon={false} style={{marginBottom: 11}}>
                    
                    {this.renderDisplayDate()}
                    <span style={{color: "red"}}>{this.state.errors["display_date"]}</span>
                     
                  </FormItem>
                  <Row style={{ marginBottom: "5px", fontSize: "16px" }}>
                    <strong>Notifications</strong>
                  </Row>

                  <Row style={{ marginBottom: "5px" }}>
                    <Col span={16}><p style={{fontSize: "13px", fontWeight: "bold" }}>Send push notification when the event is live</p></Col>
                    <Col span={4}>
                      <Switch 
                      checked ={this.state.data.enable_push_notification}
                      onChange={this.updatePushNotificationStatus} />
                    </Col>
                  </Row>

                  <FormItem {...formItemLayout} label="Push notification title" colon={false} style={{marginBottom: 11}}>
                    <Col span={18}>
                      <Input
                        value={this.state.data.notification_title}
                        onChange={this.updateNotificationTitle}
                        maxLength="35"
                      />
                      <p style={{fontSize: "12px" }}>Up to 35 characters</p>
                    </Col>
                   
                  </FormItem>
                  <FormItem {...formItemLayout} label="Push notification description" colon={false} style={{marginBottom: 11}}>
                    <Col span={18}>
                      <TextArea
                        value={this.state.data.notification_description}
                        onChange={this.updateNotificationDescription}
                        rows={3}
                        maxLength="70"
                      />
                      <p style={{fontSize: "12px" }}>Up to 70 characters</p>
                    </Col>
                  </FormItem>

                  <Row style={{ marginBottom: "5px", fontSize: "16px" }}>
                    <p style={{fontSize: "13px", fontWeight: "bold" }}>Note: The push notification will redirect the customer to the page of the event</p>
                  </Row>

                </Col>
              </Row>
            </Form>  
          </Card>
          <BackTop /> 
        </div>  
      )
    }
}

const WrappedCreateCalendarEventForm = Form.create()(CreateCalendarEvent);
export default WrappedCreateCalendarEventForm;